import adminAPI from "../../api/apiAdmin";
import { useNotification } from "../../context/NotificationContext";

class AdminCategoryService {
    static async create(categories) {
      const formData = new FormData();
  
      const payload = categories.map((c) => ({
        name: c.name.trim(),
        unit_measurement:
          c.unitMeasurement === "Custom"
            ? c.customUnitMeasurement.trim()
            : c.unitMeasurement.trim(),
      }));
  
      formData.append("data", JSON.stringify(payload));
  
      categories.forEach((cat, index) => {
        if (cat.image) {
          formData.append(`image_${index}`, cat.image);
        }
      });
  
      const res = await adminAPI.post("/admin/categories", formData);
      return res.data;
    }
  
    // Fetch all categories from server
    static async list() {
        const res = await adminAPI.get("/admin/categories");
        return res.data.data; // array of categories
    }

    // Fetch unit measurements
    static async getUnitMeasurements() {
        const res = await adminAPI.get("/admin/categories/unit-measurements");
    
        // Always append Custom at the end (UI concern)
        return [...res.data.data, "Custom"];
    }

    // Update category
    static async update(category) {
        const formData = new FormData();
      
        const payload = {
          name: category.name.trim(),
          unit_measurement: category.unitMeasurement.trim(),
        };
      
        formData.append("data", JSON.stringify(payload));
      
        if (category.image instanceof File) {
          formData.append("image", category.image);
        }
      
        const res = await adminAPI.put(
          `/admin/categories/${category.id}`,
          formData
        );
      
        return res.data.data; // updated category
      }

    // Delete category (soft delete)
    static async delete(categoryId) {
        const res = await adminAPI.delete(`/admin/categories/${categoryId}`);
        return res.data;
    }

    // Toggle status
    static async toggleStatus(categoryId) {
        const res = await adminAPI.patch(`/admin/categories/${categoryId}/status`);
        return res.data.data; // updated category
    }


  }
  
  export default AdminCategoryService;